<template>
  <NavBar  pageName="PrepaidSimCards"></NavBar>
  <BuyNewSIMCardService v-if="showAddNewImsi"   @newClientServiceAddedEvent="newClientServiceAdded" @dialogClosedEvent="closeBuyNewSIMCardService"></BuyNewSIMCardService>
  <BuyNewBenefito10PrepaidCard></BuyNewBenefito10PrepaidCard>
  <v-container style="margin-top: 185px;">
    <v-btn @click="buyNewSIMCard" class="btn btn-success">Buy Benefito 10 SIM Card</v-btn>
  </v-container>

</template>

<script>
import { defineComponent } from 'vue';
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {log} from "@/composables/useLog";
import NavBar from "@/components/NavBar.vue";
import store from "@/store";
import BuyNewSIMCardService from "@/components/BuyNewSIMCardService.vue";
import BuyNewBenefito10PrepaidCard from "@/components/BuyNewBenefito10PrepaidCard.vue";
// Components

export default defineComponent({
  name: 'DashBoard',
  components: {
    BuyNewSIMCardService,
    BuyNewBenefito10PrepaidCard,
    NavBar
  },
  data() {
    return {
      showToken:false,
      token:'',
      clientsListLoaded:false,
      showAddNewImsi:false,
    }
  },
  methods: {
    closeBuyNewSIMCardService(){
      this.showAddNewImsi=false
    },
    newClientServiceAdded(){
      this.showAddNewImsi=false
    },
    buyNewSIMCard(){
      //opens the BuyNewSIMCard component
      this.showAddNewImsi=true
    },
    showClientsList() {
      // alert("am primit emisia")
      this.clientsListLoaded=true
    }
  },
  created() {
    const {getLoggedIn, user, loggedIn, userAvatar,token}=useGetLoggedIn()
    getLoggedIn().then(()=>{
      // timestamp("autorizare in HomeloggedIn after getLoggedIn")
      log ("dupa created in Dashboard avem:")
      log("autorizare in Dashboard after getLoggedIn")
      log("user:")
      log(user)
      log("loggedIn: " + loggedIn.value)
      log("token: " + token.value)
      log("userAvatar: " + userAvatar)
      this.token=store.getters.getToken
      // this.showToken=true
    })
  }
});
</script>
